/**
 * 手当申請 承認詳細
 * 手本: ApprovalOverTimeApplicationDomain
 * 相違: 申請値を明細（detailList）で N 件持つ
 */

export interface ApprovalAllowanceDetail {
  allowanceId: string,
  allowanceCode: string,
  allowanceName: string,
  dispMessage: string,
  dispUnit: string,
  allowanceValue: number | null,
  comment: string,
}

export interface ApprovalAllowanceApplication {
  modifierApplicationId: string,
  companyCode: string,
  applicationDate: string,
  orgCode: string,
  staffCode: string,
  applicationStaffCode: string,
  approvalStaffCode: string,
  applicationStatus: number,
  modifiyStatus: number,
  applicationReason: string,
  rejectReason: any,
  version: number,
  approvalDate: Date,
  orgName: string,
  staffName: string,
  approvalStaffName: string,
  applicationStaffName: string,
  targetDate: string,
  detailList: ApprovalAllowanceDetail[],
}

export default class ApprovalAllowanceApplicationDomain {
  constructor(private rawData: ApprovalAllowanceApplication) {
    // do nothing
  }

  static generateInitial(): ApprovalAllowanceApplicationDomain {
    return new ApprovalAllowanceApplicationDomain({
      modifierApplicationId: '',
      companyCode: '',
      applicationDate: '',
      orgCode: '',
      staffCode: '',
      applicationStaffCode: '',
      approvalStaffCode: '',
      applicationStatus: 0,
      modifiyStatus: 0,
      applicationReason: '',
      rejectReason: '',
      version: 0,
      approvalDate: new Date(),
      orgName: '',
      staffName: '',
      approvalStaffName: '',
      applicationStaffName: '',
      targetDate: '',
      detailList: [],
    });
  }

  getRawData(): ApprovalAllowanceApplication {
    return this.rawData;
  }

  get modifierApplicationId(): string {
    return this.rawData.modifierApplicationId;
  }

  get orgCode(): string {
    return this.rawData.orgCode;
  }

  get applicationStaffCode(): string {
    return this.rawData.applicationStaffCode;
  }

  get approvalStaffCode(): string {
    return this.rawData.approvalStaffCode;
  }

  get approvalStaffName(): string {
    return this.rawData.approvalStaffName;
  }

  get version(): number {
    return this.rawData.version;
  }

  get orgName(): string {
    return this.rawData.orgName;
  }

  get staffCode(): string {
    return this.rawData.staffCode;
  }

  get staffName(): string {
    return this.rawData.staffName;
  }

  get targetDate(): string {
    return this.rawData.targetDate;
  }

  get applicationStatus(): number {
    return this.rawData.applicationStatus;
  }

  get modifiyStatus(): number {
    return this.rawData.modifiyStatus;
  }

  get applicationReason(): string {
    return this.rawData.applicationReason;
  }

  get rejectReason(): any {
    return this.rawData.rejectReason;
  }

  get applicationStaffName(): string {
    return this.rawData.applicationStaffName;
  }

  get applicationDate(): string {
    return this.rawData.applicationDate;
  }

  get detailList(): ApprovalAllowanceDetail[] {
    return this.rawData.detailList || [];
  }
}
